"use client"

import { ErrorCause } from "@/api/default-query"

const FORBIDDEN_IN_DEMO = "FORBIDDEN_IN_DEMO"

export const isForbiddenInDemoError = (error: Error) => {
  const cause = error.cause as ErrorCause
  return cause.status === 403 && cause.code === FORBIDDEN_IN_DEMO
}
